import { render } from "./ConfirmReportedDamage.vue?vue&type=template&id=2cf14fd4&scoped=true&ts=true"
import script from "./ConfirmReportedDamage.vue?vue&type=script&lang=ts"
export * from "./ConfirmReportedDamage.vue?vue&type=script&lang=ts"

import "./ConfirmReportedDamage.vue?vue&type=style&index=0&id=2cf14fd4&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf14fd4"]])

export default __exports__